// eslint-disable-next-line no-unused-vars
import { Fancybox } from '@fancyapps/ui';
import Faqs from '../../../frontend/blocks/faqs/faqs.js';
import HeaderScroll from './components/HeaderScroll.js';
import MobileMenu from './components/MobileMenu.js';
import DonateMenu from './components/DonateMenu.js';
import Toggle from './components/Toggle.js';
import FooterToggle from './components/FooterToggle.js';
import Tabs from './components/Tabs.js';
import GformUpload from './components/GformUpload.js';
import SmoothScroll from './components/SmoothScroll.js';
import GeneralHero from '../../../frontend/blocks/general-hero/general-hero.js';
import ImageGalleryVideoSlider from '../../../frontend/blocks/image-gallery-video/image-gallery-video';
import '../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.js';
import MediaTextarea from '../../../frontend/blocks/media-textarea/media-textarea';
import Quotes from '../../../frontend/blocks/quotes/quotes.js';
import Animate from './components/Animate.js';
import GFormStyling from './components/GFormStyling.js';
import CustomSearch from './components/CustomSearch.js';
import StatsColumns from '../../../frontend/blocks/stats-columns/stats-columns.js';
import GFLiveTotal from './components/GFLiveTotal.js';
import GFFunnelSteps from './components/GFFunnelSteps.js';
import GFFeeCover from './components/GFFeeCover.js';
import DonationWidget from './components/DonationWidget.js';
import DonationWidgetAppeal from './components/DonationWidgetAppeal.js';
import GTranslate from './components/GTranslate.js';
import Backlink from './components/Backlink.js';
import AppealHero from '../../../frontend/blocks/appeal-hero/appeal-hero.js';
import SearchClear from './components/SearchClear.js';
import EventSearchClear from './components/EventSearchClear.js';
import CookiePreferences from './components/CookiePreferences.js';
import CookieRefresh from './components/CookieRefresh.js';
import TributeWall from '../../../frontend/blocks/tribute-wall/tribute-wall';

CookieRefresh();

{
    Animate();
}

{
    const eventSearchClear = document.querySelector('.tribe-events-c-search__input');
    if (typeof eventSearchClear !== 'undefined' && eventSearchClear !== null) {
        EventSearchClear();
    }
}

{
    const searchClear = document.querySelector('.search-page__field');
    if (typeof searchClear !== 'undefined' && searchClear !== null) {
        SearchClear();
    }
}

{
    const backlink = document.querySelector('.js-backlink');

    if (typeof backlink != 'undefined' && backlink != null) {
        Backlink();
    }
}

{
    const appealHero = document.querySelector('.appeal-hero');

    if (typeof appealHero != 'undefined' && appealHero != null) {
        AppealHero();
    }
}

{
    const donationWidget = document.querySelector('.donation-widget');

    if (typeof donationWidget != 'undefined' && donationWidget != null) {
        DonationWidget();
    }
}

{
    const donationWidgetAppeal = document.querySelector('.donation-widget-appeal');

    if (typeof donationWidgetAppeal != 'undefined' && donationWidgetAppeal != null) {
        DonationWidgetAppeal();
    }
}

{
    const gfFeeCover = document.querySelector('.donation-funnel');

    if (typeof gfFeeCover != 'undefined' && gfFeeCover != null) {
        GFFeeCover();
    }
}

{
    const gfFunnelSteps = document.querySelector('.donation-funnel');

    if (typeof gfFunnelSteps != 'undefined' && gfFunnelSteps != null) {
        GFFunnelSteps();
    }
}

{
    const gfLiveTotal = document.querySelector('.donation-funnel');

    if (typeof gfLiveTotal != 'undefined' && gfLiveTotal != null) {
        GFLiveTotal();
    }
}

{
    const customSearch = document.querySelector('.search-form');

    if (typeof customSearch != 'undefined' && customSearch != null) {
        CustomSearch();
    }
}

{
    const gFormStyling = document.querySelector('.gform_wrapper');

    if (typeof gFormStyling != 'undefined' && gFormStyling != null) {
        GFormStyling();
    }
}

{
    const statsColumns = document.querySelector('.stats-columns');

    if (typeof statsColumns != 'undefined' && statsColumns != null) {
        StatsColumns();
    }
}

{
    const mediaTextarea = document.querySelector('.media-textarea__swiper');

    if (typeof mediaTextarea != 'undefined' && mediaTextarea != null) {
        MediaTextarea();
    }
}

{
    const tributeWall = document.querySelector('.tribute-wall__container--items');

    if (typeof tributeWall != 'undefined' && tributeWall != null) {
        TributeWall();
    }
}

{
    const header = document.querySelector('.header');

    if (typeof header != 'undefined' && header) {
        HeaderScroll();
    }
}

{
    const faqs = document.querySelector('[data-question]');

    if (typeof faqs != 'undefined' && faqs) {
        Faqs();
    }
}

{
    const mobile_menu = document.querySelector('.mobile-menu');

    if (typeof mobile_menu != 'undefined' && mobile_menu) {
        MobileMenu();
    }
}

{
    const donate_menu = document.querySelector('.donate-menu__menu');

    if (typeof donate_menu != 'undefined' && donate_menu) {
        DonateMenu();
    }
}

{
    const toggle_element = document.querySelector('[data-toggle]');

    if (typeof toggle_element != 'undefined' && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector('[data-footer-toggle]');

    if (typeof footer_toggle != 'undefined' && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector('[data-tabs]');

    if (typeof tabs != 'undefined' && tabs != null) {
        Tabs();
    }
}

{
    // eslint-disable-next-line no-undef
    if (typeof gform != 'undefined' && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector('[data-smooth-scroll]');

    if (typeof anchorLink != 'undefined' && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const generalHero = document.querySelector('.hero__swiper');
    if (typeof generalHero != 'undefined' && generalHero != null) {
        GeneralHero(generalHero);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector('.image-gallery-video__swiper-wrapper');

    if (typeof imageGalleryVideoSlider != 'undefined' && imageGalleryVideoSlider != null) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const quotes = document.querySelector('.quotes__swiper');
    if (typeof quotes != 'undefined' && quotes != null) {
        Quotes(quotes);
    }
}

{
    const cookiePreferences = document.querySelector('.bottom-footer__cookies');
    if (typeof cookiePreferences !== 'undefined' && cookiePreferences != null) {
        CookiePreferences();
    }
}

{
    GTranslate();
}
